
// Stable client-side key generator for dynamically add/remove/reorder-able
// list items (e.g. RFQ line items, SOP steps) where array index alone is an
// unstable React key across mutation.
let _keySeq = 0;
export function genKey() {
  _keySeq += 1;
  return `k${Date.now()}_${_keySeq}`;
}

export function fmtDate(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return "—";
  const m = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${d.getDate()} ${m[d.getMonth()]} ${("" + d.getFullYear()).slice(2)}`;
}

export function fmtDateTime(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d)) return "—";
  const m = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${d.getDate()} ${m[d.getMonth()]} ${("" + d.getFullYear()).slice(2)} · ${hh}:${mm}`;
}

export function money(v) {
  if (v == null || v === "") return "—";
  return "R " + Number(v).toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function fmtNum(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("en-ZA");
}

// Humanises equipment.calibration_period_days / job_items.calibration_period_days
// (the customer- or item-specific calibration cycle, e.g. Sandvik's 2-year
// override or Barloworld's standard 3-year cycle) into a short label a
// technician can act on at a glance — falls back to "X days" for any
// non-standard value instead of hiding it.
const _CAL_PERIOD_LABELS = { 180: "6 Months", 365: "1 Year", 547: "18 Months", 730: "2 Years", 1095: "3 Years", 1460: "4 Years", 1825: "5 Years", 2190: "6 Years" };
export function fmtCalPeriod(days) {
  if (days == null || days === "") return null;
  const n = Number(days);
  if (!n || Number.isNaN(n)) return null;
  return _CAL_PERIOD_LABELS[n] || `${n} days`;
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((w) => w[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
}
